import React, { useState, useEffect, useCallback } from 'react';
import Button from '../components/Button';
import { BrowserRouter as Router, Route, Switch, Link, useNavigate, useFetcher } from 'react-router-dom';
import { usePrompt } from '../hooks/usePrompt';
import axios from 'axios';
import { SaveThree, GetWC } from '../utils/bridge';
import Spinner  from '../utils/Spinner';
import { useGoToStep } from '../hooks/useGoToStep';

import { logMessage } from '../hooks/logger';
import toast, { Toaster } from 'react-hot-toast';

import { useInputChanged } from '../context/InputChangedContext';


const Paso3 = ({ usr }) => {

    const { setInputChanged, setValidDataInputs } = useInputChanged();

    const [formData, setFormData] = useState({
        trabaja: '',
        entidad: '',
        direccion: '',
        cargo: '',
        departamento: '',
        telefono: '',
        correo: '',
        correouser: usr,
        relaciona: '',
        result: ['', '']  
    });


    const [validError, setValidError] = useState('');    
    const [isInitialLoad, setInitialLoad] = useState(true);
    const [ campoHabil, setCampoHabil ] = useState(false);


    useEffect(() => {
            if (usr) {
                setFormData((prevState) => ({
                    ...prevState,
                    correouser: usr
                }));
            }
        }, [usr]);

 
    const [isUnsave, setIsUnsave] = useState(false);
    const navigate = useNavigate();


      useEffect(() => {
            setIsUnsave(
                formData.trabaja !== '' || formData.entidad !== '' || formData.direccion !== '' || formData.cargo !== ''
                || formData.departamento !== '' || formData.telefono !== '' || formData.correo !== '' || formData.relaciona !== ''
            );
    
            //console.log(formData);
    
            setCampoHabil(formData.trabaja === 'si');           

        }, [formData]);

        useEffect(() => {
                
            const unsave = 
                formData.trabaja !== '' || formData.entidad !== '' || formData.direccion !== '' || formData.cargo !== ''
                || formData.departamento !== '' || formData.telefono !== '' || formData.correo !== '' || formData.relaciona !== ''

            setInputChanged(unsave);

            // calcula si el formulario está completo
            const valid = 
            !!formData.trabaja.trim() ||
            !!formData.entidad.trim() ||
            !!formData.direccion.trim() ||
            !!formData.cargo.trim() ||
            !!formData.departamento.trim() ||        
            !!formData.correouser.trim() ||
            !!formData.relaciona.trim();

            setValidDataInputs(valid);
        }, [formData, setInputChanged, setValidDataInputs]);


        useEffect(() => {
          if(formData.trabaja === "no"){ handleReset();} 
        }, [formData.trabaja]); 
        


     const handleRadioChange = (e) => {    
        const selectedValue = e.target.value;

        //console.log("handleRadioChange")
        //console.log(e.target.value)
        //console.log(selectedValue === 'si')

        setCampoHabil(selectedValue === 'si');

        const { name, value } = e.target;

        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'telefono') {
            let digitos = value.replace(/\D/g, '');
            const codigoAreaDominicano = /^(809|829|849)/.test(digitos);

            //revisamos si es 1809/1829/1849, ese "1" es un dolor de cabeza
            if (/^(1809|1829|1849)/.test(digitos)) {
                digitos = digitos.slice(1); // eliminamos el '1' inicial
            }

            //const newVal = value.replace(/[^0-9-]/g, '').slice(0,12);

            let newVal;
            if (codigoAreaDominicano) {
                
                if (digitos.length <= 3) {
                        newVal = digitos;
                } else if (digitos.length <= 6) {
                        newVal = digitos.slice(0, 3) + '-' + digitos.slice(3);
                } else {
                        newVal = digitos.slice(0, 3) + '-' + digitos.slice(3, 6) + '-' + digitos.slice(6, 10);
                }
            } else {
                // Para internacionales, no formatear (solo limitar la longitud si quieres)
                newVal = digitos.slice(0, 16); // puedes ajustar 15 como máximo permitido
            }
            setFormData((prevState) => ({
                ...prevState,
                [name]: newVal
            }));

        }
        else{
            setFormData((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }
       
    };


    const validateError = () => {
        const errors = {};        
        if (!formData.trabaja.trim() && (formData.trabaja !== "si" || formData.trabaja !== "no")) errors.trabaja = 'Completar el campo trabaja es obligatorio';        
        if (!formData.entidad.trim() && formData.trabaja === "si") errors.entidad = 'Completar el campo entidad es obligatorio si trabaja';
        if (!formData.direccion.trim() && formData.trabaja === "si") errors.direccion = 'Completar el campo dirección es obligatorio si trabaja';
        if (!formData.cargo.trim() && formData.trabaja === "si") errors.cargo = 'Completar el campo cargo es obligatorio si trabaja';
        if (!formData.departamento.trim() && formData.trabaja === "si") errors.departamento = 'Completar el campo departamento es obligatorio si trabaja';
        if (!formData.telefono.trim() && formData.trabaja === "si") errors.telefono = 'Completar el campo teleono es obligatorio si trabaja';
        if (!formData.correo.trim() && formData.trabaja === "si") errors.correo = 'Completar el campo correo laboral es obligatorio si trabaja';        
        if (!formData.relaciona.trim() && formData.trabaja === "si") errors.relaciona = 'Completar el campo si se relaciona lo que estudia es obligatorio si trabaja';        

        return errors;
    }


    const handleReset = () => {
        setFormData({
           ...formData,          
           entidad: '',
           direccion: '',
           cargo: '',
           departamento: '',
           telefono: '',
           correo: '',           
           relaciona: '' 
        });
    };


    /*const handleSubmit = async (e) => {
        e.preventDefault();


        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }

        
        setValidError({});
        
        if(formData.trabaja === "no"){ await handleReset();} 

        const save = async () => {  
            setInitialLoad(true);          
            try {                                                
                const res = await axios.post(`${SaveThree}`, formData); 
                //console.log(res)                
                toast.success(`${res.data.datos}`);                
            } catch (error) {
                if (error.response) {                    
                    console.log(error.response.data.mensajeError)
                    const errorMessage = error.response.data.mensajeError;
                    logMessage('Error', '⚠ Paso 3: Error del servidor (4xx,5xx):', errorMessage);
                    toast.error(`${errorMessage}`);
                } else {
                    toast.error(`Error: sin respuesta del servidor`);
                }

            }finally{
                setInitialLoad(false); 
            }
        }
          
        save();
        
    }*/

    const save = useCallback(async () => {
        setInitialLoad(true);
        try {
            const res = await axios.post(`${SaveThree}`, formData);
            toast.success(`${res.data.datos}`);
        } catch (error) {
            toast.error("Error al guardar los datos");
            const errorMessage = error.response.data.mensajeError;
            logMessage('Error', '⚠ Paso 3: Error del servidor (4xx,5xx):', errorMessage);
        } finally {
            setInitialLoad(false);
        }
    }, [formData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }

        setValidError({});
        
        if(formData.trabaja === "no"){ await handleReset();}
        await save();
    };

    const { setSaveFn } = useInputChanged();
    useEffect(() => {
        setSaveFn(() => save);
    }, [save, setSaveFn]);
    
    const InitialLoad = async () => {
        
        const responseGet =  axios.get(`${GetWC}/${usr}`).then(response => {
            if (response.data) {
                setFormData({ ...formData, ...response.data });                    
            }
        }).catch(error => {
            if (error.response) {
                console.error('⚠ Error del servidor (4xx,5xxg):', error.response.status);
            } else if (error.request) {
                console.error('No se pudo conectar (API caída, red, CORS bloqueadog)');
            } else {
                console.error('Error desconocidog: ', error.message);
                logMessage('Error', '⚠ Paso 3: Error desconocido:', error.message);
            }
        });

        setInitialLoad(false);
    }


    useEffect(() => {

        if (isInitialLoad) {
             InitialLoad();
        }

    }, []);


    const validDataInputs =
        !!formData.trabaja.trim() ||
        !!formData.entidad.trim() ||
        !!formData.direccion.trim() ||
        !!formData.cargo.trim() ||
        !!formData.departamento.trim() ||        
        !!formData.correouser.trim() ||
        !!formData.relaciona.trim();

    // Hook global para navegación entre pasos
    /*const goToStep = useGoToStep(validDataInputs);
    const handleNext = (e) => goToStep(e, "paso4");
    const handleBack = (e) => goToStep(e, "paso2");*/
    const { goToStep, ConfirmModal, IncompleteModal } = useGoToStep(save);

    const oldhandleNext = (e) => {
        e.preventDefault();
        //console.log("validar")
        //console.log(formData)

        if (validDataInputs) {
            const confirm = window.confirm(
                'Cambios detectados en el formulario. ¿Seguro que desea continuar sin guardar?'
            );
            if (!confirm) {
                e.preventDefault();
                return;
            } else {
                navigate("/paso4");
            }
        }
        navigate("/paso4");
    };


  if (isInitialLoad) return <Spinner />;


    return (
        <div>
            <div className="encab-contenido">
                <h1>Actualización de datos personales y laborales</h1>
            </div>

            <div className="pasos">
                <Link /*to="/paso2"*/ className="ant" onClick={(e)=> goToStep(e, "paso2")}><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Anterior</span></Link>
                <h2>Paso 3 de 4</h2>
                <Link /*to="/paso4"*/ className="sig" onClick={(e)=> goToStep(e, "paso4")}><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Siguiente</span></Link>
            </div>

            <h3>Información laboral</h3>

            <form>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="trabajaActualmente" className="fieldset-bordes mt-3 mb-3">
                            <legend id="trabajaActualmente"><strong>Trabaja actualmente:</strong></legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-trabajo-si"
                                    name="trabaja"
                                    checked={formData.trabaja === 'si'}
                                    value= "si"
                                    onChange={handleRadioChange}
                                    className="form-check-input"                                    
                                />
                                <label className="form-check-label" htmlFor="radio-trabajo-opc1"> Sí </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="radio-trabajo-no"
                                    name="trabaja"
                                    checked={formData.trabaja === 'no'}
                                    value="no"
                                    onChange={handleRadioChange}
                                    className="form-check-input"                                                                  
                                />
                                <label className="form-check-label" htmlFor="radio-trabajo-opc2"> No </label>
                            </div>
                            <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.trabaja ? 'red' : 'gray' }}>
                                {validError.trabaja ? validError.trabaja : ''}
                            </p>
                        </div>
                        </fieldset>
                    </div>
                </div>

                <div className="row">
                    <div className="col mt-3">
                        <label htmlFor="text-entidad" className="form-label"><strong>Entidad:</strong></label>
                        <input
                            type="text"
                            disabled ={!campoHabil}
                            id="text-entidad"
                            name="entidad"
                            value={formData.entidad}
                            onChange={handleChange}
                            className="form-control"                            
                        />
                    </div>
                    <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.entidad ? 'red' : 'gray' }}>
                                {validError.entidad ? validError.entidad : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col mt-3">
                        <label htmlFor="input-direccion" className="form-label"><strong>Dirección:</strong></label>
                        <input
                            type="text"
                            disabled ={!campoHabil}
                            id="text-direccion"
                            name="direccion"
                            value={ formData.direccion }
                            onChange={handleChange}
                            className="form-control"                                                      
                        />
                    </div>
                     <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.direccion ? 'red' : 'gray' }}>
                                {validError.direccion ? validError.direccion : ''}
                            </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="input-cargo" className="form-label"><strong>Cargo que ocupa:</strong></label>
                        <input
                            type="text"
                            disabled ={!campoHabil}
                            id="text-cargo"
                            name="cargo"
                            value={formData.cargo}
                            onChange={handleChange}
                            className="form-control"                                                      
                        />
                         <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.cargo ? 'red' : 'gray' }}>
                                {validError.cargo ? validError.cargo : ''}
                            </p>
                    </div>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-departamento" className="form-label"><strong>Departamento:</strong></label>
                        <input
                            type="text"
                            disabled ={!campoHabil}
                            id="text-departamento"
                            name="departamento"
                            value={formData.departamento}
                            onChange={handleChange}
                            className="form-control"                                                        
                        />
                    <div id="ayuda-formato-direccion" className="form-text">
                      <p style={{ color: validError.departamento ? 'red' : 'gray' }}>
                        {validError.departamento ? validError.departamento : ''}
                      </p>
                    </div>
                    </div>                    
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-telefonoTrab" className="form-label"><strong>Teléfono:</strong></label>
                        <input
                            type="text"
                            disabled ={!campoHabil}
                            id="text-telefonoTrab"
                            name="telefono"
                            value={formData.telefono}
                            onChange={handleChange}
                            className="form-control"                                                                                    
                        />
                        <div id="ayuda-formato-telefono" className="form-text">Solo ingresar números y guiones</div>
                         <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.telefono ? 'red' : 'gray' }}>
                                {validError.telefono ? validError.telefono : ''}
                            </p>
                    </div>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-correoTrab" className="form-label"><strong>Correo electrónico:</strong></label>
                        <input
                            type="text"      
                            disabled ={!campoHabil}                      
                            id="text-correoTrab"
                            name="correo"
                            value={formData.correo}
                            onChange={handleChange}
                            className="form-control"
                        />
                          <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.correo ? 'red' : 'gray' }}>
                                {validError.correo ? validError.correo : ''}
                            </p>
                    </div>
                    </div>                    
                       
                </div>

                <div className="row">
                    <div className="col">
                        <fieldset role="group" aria-labelledby="relacionTrabajoEstudios" className="mt-3 mb-3">
                            <legend id="relacionTrabajoEstudios"><strong>El puesto que ocupa se relaciona a los estudios realizados:</strong></legend>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    disabled ={!campoHabil}                                          
                                    id="radio-relEstudios-opc1"
                                    name="relaciona"
                                    checked={formData.relaciona === 'si'}
                                    value="si"
                                    onChange={handleRadioChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-relEstudios-opc1"> Sí </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    disabled ={!campoHabil}   
                                    id="radio-relEstudios-opc2"
                                    name="relaciona"
                                    checked={formData.relaciona === 'no'}
                                    value="no"
                                    onChange={handleRadioChange}
                                    className="form-check-input"
                                />
                                <label className="form-check-label" htmlFor="radio-relEstudio-opc2"> No </label>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.relaciona ? 'red' : 'gray' }}>
                                {validError.relaciona ? validError.relaciona : ''}
                            </p>
                </div>
                <span className="separador"></span>

                <div className="form-botones">
                    <Button children="Guardar" onClick={handleSubmit} variant='primary'></Button>                   
                </div>
            </form>
            <Toaster position="top-center" reverseOrder={false} />
            {/* Modal */}
                <ConfirmModal />
                <IncompleteModal />
            {/* Fin Modal */}
        </div>

    )
};


export default Paso3;